export default "__VITE_ASSET__2c5b1ef0__"